import { Maybe, Effect3D } from "nvs-types/dist/types/generated/contentful";
import { EffectType } from "./types";

export const effectSelectorProps = {
  bloom: {
    luminanceThreshold: 0.5,
    luminanceSmoothing: 0.99,
  },
  chromaticAberration: {
    offset: [0.0015, 0.0003],
    blendFunction: 28,
  },
  dotScreen: {
    angle: 0.5,
    scale: 1,
    opacity: 0.05,
    blendFunction: 16,
  },
  noise: {
    opacity: 0.075,
  },
  toneMapping: true,
};

export const effects3D: Partial<Effect3D>[] = [
  {
    effectType: "ChromaticAberration",
    name: "Chromatic Aberration",
  },
  {
    effectType: "Noise",
    name: "Noise",
  },
  {
    effectType: "DotScreen",
    name: "DotScreen",
  },
  {
    effectType: "Bloom",
    name: "Bloom",
  },
  {
    effectType: "ToneMapping",
    name: "ToneMapping",
  },
];

// We need to map one value to another to match the expected FX config.
export const FxConfigTypeMap = {
  [EffectType.Bloom]: "bloom",
  [EffectType.DotScreen]: "dotScreen",
  [EffectType.Noise]: "noise",
  [EffectType.ChromaticAberration]: "chromaticAberration",
  [EffectType.ToneMapping]: "toneMapping",
};
